"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promoVideoComponent = exports.SpotPlayVideoComponent = void 0;
var tslib_1 = require("tslib");
var app_1 = require("app");
var PreviewBox_1 = require("../PreviewBox/PreviewBox");
var SpotPlayVideoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SpotPlayVideoComponent, _super);
    function SpotPlayVideoComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = [
            '.spot-two_plus_one .cta--play-video',
            '.spot-product .spot-product__cta-with-video',
            '.spot-group-cascade .cta--play-video',
            '.spot-multilink .cta--play-video',
            '.spot-singlelink .cta--play-video',
            '.expand-collapse-elem .cta--play-video',
            '.spot-cascade .cta--play-video',
        ].join(', ');
        return _this;
    }
    SpotPlayVideoComponent.prototype.OnInit = function () {
        $(this.el).prev('picture, .img-empty, .img-empty-wrapper ').css('cursor', 'pointer');
        this.el.forEach(function (el) {
            el.addEventListener('click', function (event) {
                (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, this);
            });
        });
        this.el.forEach(function (el) {
            el.addEventListener('keypress', function (event) {
                if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                    (0, PreviewBox_1.showPreviewBoxWithDataFromImage)(event, this);
                }
            });
        });
        $(this.el)
            .prev('picture, .img-empty, .img-empty-wrapper')
            .click(function () {
            $(this).next('.cta--play-video').click();
        });
    };
    return SpotPlayVideoComponent;
}(app_1.Component));
exports.SpotPlayVideoComponent = SpotPlayVideoComponent;
exports.promoVideoComponent = new SpotPlayVideoComponent();
